import { render, staticRenderFns } from "./VideoChapterAdd.vue?vue&type=template&id=43ac597b&scoped=true"
import script from "./VideoChapterAdd.vue?vue&type=script&lang=js"
export * from "./VideoChapterAdd.vue?vue&type=script&lang=js"
import style0 from "./VideoChapterAdd.vue?vue&type=style&index=0&id=43ac597b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ac597b",
  null
  
)

export default component.exports